import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Client } from 'app/core/models/client.model';
import { PatientFilters } from 'app/core/models/user-settings/patient-search-settings.model';
import { ClientsService } from 'app/core/services/clients.service';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
    selector: 'app-patient-filters',
    templateUrl: './patient-filters.component.html',
    styleUrls: ['./patient-filters.component.scss'],
    imports: [FormsModule, NgSelectComponent]
})
export class PatientFiltersComponent implements OnInit {
  private clientsService = inject(ClientsService);

  @Input() filters: PatientFilters;
  @Output() public filtersChange = new EventEmitter<PatientFilters>();

  clients: Client[] = [];

  ngOnInit() {
    this.init();
  }

  emitFilterChange() {
    this.filtersChange.emit(this.filters);
  }

  onFormEnter($event) {
    $event.preventDefault();
    this.emitFilterChange();
  }

  onClearAllClick($event) {
    $event.preventDefault();
    this.filters = new PatientFilters();
    this.emitFilterChange();
  }

  onSubmit() {
    this.emitFilterChange();
  }

  private init() {
    this.loadClients();
  }

  private loadClients() {
    this.clientsService.getList(null, { applicableToReferralClaims: true }).subscribe(result => {
      this.clients = result.clients;
    });
  }
}
